import * as React from 'react';

import useFooterColors from '../../hooks/use-footer-color';
import { useMatchMedia } from '../../hooks/use-match-media';
import { ScContainer } from '../container/styled';

import { DesktopFooter } from './desktop-footer';
import { MobileFooter } from './mobile-footer';
import { ScFooterLogos, ScFooterWrapper } from './styled';
import { useTheme } from 'styled-components';
import { useLocation } from '@reach/router';

export const Footer = ({ openModal }: { openModal: (modalType: string) => void }) => {
	const color = useFooterColors();
	const isDesktop = useMatchMedia(`(min-width: 1220px)`);
	const theme = useTheme();
	const location = useLocation();

	return (
		<ScContainer backgroundColor={location.pathname === '/' ? theme.colors.wheat : ''}>
			<ScFooterWrapper color={color}>
				{isDesktop !== undefined &&
					(isDesktop ? (
						<DesktopFooter openModal={openModal} />
					) : (
						<MobileFooter openModal={openModal} />
					))}
				<ScFooterLogos color={color} />
			</ScFooterWrapper>
		</ScContainer>
	);
};
